import {Box, Skeleton } from '@mui/material'


export const SkeletonCom = ({height,style}) => {
    return (
        <Skeleton variant="rounded" width={"100%"} height={height || 220} style={{ borderRadius: "15px",...style }} animation="wave" />
    )
}

export const TextSkeleton = ({ width, line, margin, sx }) => {
    return (
        <Box sx={{ width: width || 300, margin: margin, ...sx }}>
            {[...Array(line ?? 3)].map((_, index) => (
                <Skeleton
                    key={index}
                    variant="text"
                    sx={{
                        fontSize: '1rem',
                        ...sx,
                    }}
                    animation="wave"
                />
            ))}
        </Box>
    );
};


export const FormSkeleton = ({height,style}) => {
    return (
        <Skeleton variant="rectangular" width={"100%"} height={height || 40} style={{ borderRadius: "5px",...style }} animation="wave" />
    )
}


